import React, { useState, useEffect } from "react"
import {
  Button,
  CardBody,
  CardHeader,
  Input,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import { BiSearch } from "react-icons/bi"
import { FiDownloadCloud } from "react-icons/fi"

import Papa from "papaparse"
import { toast } from "react-toastify"
import moment from "moment"
import { CustomHeader } from "../../components/headers/CustomHeader"
import { Table_Headers } from "../dashboard/reports/data"
import { DEFAULTPRIMARYCOLOR } from "../../util"

import { CustomModal } from "../../components"
import { useSelector } from "react-redux"
import { RootState } from "../../store/store"
import { useDebounceSearch } from "../../hooks/useDebounce"
import useSearchReports from "../../hooks/useSearch"
import PerPageAndPagination from "../../components/paginations/perpageAndPagination"
import { getColorCode } from "../../colorCodes"
import dayjs from "dayjs";

type ResponseType = {
  account_status: string
  address: string
  balance: number
  bank_details: {
    branch: string
    bank_name: string
    account_number: string
  }
  company_staff: {
    id: string
    name: string
    phone_number_one: string
  }
  sub_agent: {
    id: string
    first_name: string
    last_name: string
    phone_number: string
  }
  total_collections: {
    aggregate: {
      sum: {
        amount: number
      }
    }
  }
  total_withdrawals: {
    aggregate: {
      sum: {
        amount: number
      }
    }
  }
  total_invest2insure_payments: {
    aggregate: {
      sum: {
        amount: number
      }
    }
  }
  driver_payments_schedules_aggregate: {
    aggregate: {
      sum: {
        arrears: number
      }
    }
  }

  total_invest2insure_payments_balance: {
    aggregate: {
      sum: {
        premium_balance: number
      }
    }
  }
  created_at: string
  consent: boolean
  dob: string
  driver_code: string
  driver_beneficiaries: [
    {
      first_name: string
      surname: string
      relationship: string
      share_percentage: number
    }
  ]
  email: string
  full_name: string
  gender: string
  id: string
  id_card_type: string
  id_number: string
  momo_wallet_details: {
    number: string
    network: string
  }
  phone_number_1: string
  phone_number_2: string
}

const Invest2InsureReport = () => {
  const [searchText, setSearchText] = useState("")
  const [data, setData] = useState<ResponseType[]>([])
  const [loading, setLoading] = useState(true)

  const [selectedRow, setSelectedRow] = useState<ResponseType>()
  const [open, setModalOpen] = useState(false)
  const defaultStart = moment().subtract(1, "months").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [totalPageSize, setTotalPageSize] = useState(0)
  const [searchTerm, setSearchTerm] = useState("");

  const {
    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  const search = useDebounceSearch<string>(searchText)
  // console.log(search)
  // const {
  //   loading: loadingData,
  //   data: reportData,
  // } = useSearchReports(search)



  const handleStartDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z"
    setStartDate(formattedValue)
    setActivePage(1)
    setSearchText("")
  }

  const handleEndDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z"
    setEndDate(formattedValue)
  }
  // console.log(startDate, endDate)
  const handleSearch = () => {
    setSearchText(searchTerm)
  }

  const handleTempStartDateChange = (event:any) => {
    const value = event.target.value
    if(value){
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event:any) => {
    const value = event.target.value
    if(value){
      const formattedValue = value 
      setTempEndDate(formattedValue)
    }
  }

  const handleDateChange = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);

    if (diffInMonths > 3) {
      setTempStartDate(defaultStart);
      setTempEndDate(defaultEnd);
      toast.error("Date range cannot exceed 3 months.");
      return;
    }
    // setIsFilterLoading(true)

    setTimeout(() => {
      setStartDate(tempStartDate);
      setEndDate(tempEndDate);
      // setIsFilterLoading(false);
    }, 1000);
  }
  

  const [activePage, setActivePage] = useState(0)
  const [pageSize, setPageSize] = useState(10)

  useEffect(() => {
    const fetchData = async () => {
      setData([])
      setLoading(true)
      try {
        const res = await fetch(
          // `${process.env.REACT_APP_BASE_URL}/get-all-report?page=${
          //   activePage + 1
          // }&limit=${pageSize}`,
          `${process.env.REACT_APP_BASE_URL}/get-all-report?start_date=${
          startDate}&end_date=${endDate}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        const req = await res.json()
        // console.log(req?.data)
        if (res?.ok) {
          if (req?.error) {
            toast.error(req?.data)
          } else {
            console.log(req)
            setData(req?.data)
            setTotalPageSize(req?.total_records)
          }
        }
        setLoading(false)
      } catch (error: any) {
        setLoading(false)
        toast.error(error?.message ?? "Something went wrong. Try again!")
      }
    }
    fetchData()
  }, [startDate, endDate, activePage, pageSize, token])

  useEffect(() => {
    if (searchText || startDate || endDate) {
      setActivePage(0)
    }
  }, [searchText, startDate, endDate])

  // useEffect(() => {
  //   if (pageSize) {
  //     setActivePage(0)
  //     setSearchText("")
  //     setStartDate("")
  //     setEndDate("")
  //   }
  // }, [pageSize])

  const handlePageChange = (page: number) => {
    setActivePage(page)
  }
  
  const filteredData = (data as ResponseType[])?.filter(
    (item: any) => {
      const normalizeDate = (date: Date | string): Date => {
        const normalizedDate = new Date(date)
        normalizedDate.setHours(0, 0, 0, 0) // Set time to midnight to include the entire day
        return normalizedDate
      }
      const from =
        (startDate as any) instanceof Date
          ? normalizeDate(startDate)
          : normalizeDate(startDate)
      const to =
        (endDate as any) instanceof Date
          ? normalizeDate(endDate)
          : normalizeDate(endDate)
      const dateCreated = normalizeDate(item?.created_at)
      // Convert date_created to Date object
      // Check if dateCreated falls within the range (inclusive)
      if (startDate && endDate) {
        return dateCreated >= from && dateCreated <= to // Corrected to <= for endDate
      } else if (startDate) {
        return dateCreated >= from // Only from date is set
      } else if (endDate) {
        return dateCreated <= to // Only to date is set
      }
      return true // No filter applied
    }
  )

 

  const lengthOfItems = filteredData?.length

  // const paginatedData = filteredData?.slice(startIndex, endIndex)

  const endOffset = activePage + pageSize
  const paginatedData = filteredData?.slice(activePage, endOffset)
  // console.log(paginatedData)

  //----------------
  const handleDownload = () => {
    // Check if there is data to download
    if (!paginatedData || paginatedData?.length === 0) {
      toast.error("No data to download.")
      return
    }

    if (searchText || startDate || endDate) {
      const change = filteredData?.map((item) => ({
        "driver code": item?.driver_code,
        "full name": item?.full_name,
        address: item?.address,
        "phone number 1": item?.phone_number_1,
        email: item?.email,
        "id card type": item?.id_card_type,
        "id number": item?.id_number,
        network: item?.momo_wallet_details?.network,
        number: item?.momo_wallet_details?.number,
        "bank name": item?.bank_details?.bank_name,
        "account number": item?.bank_details?.account_number,
        "created at": moment(item?.created_at).format("LL"),
        "company staff name": item?.company_staff
          ? item.company_staff?.name
          : `${item?.sub_agent?.first_name} ${item?.sub_agent?.last_name}`,

        "total collections": item?.total_collections?.aggregate?.sum?.amount || 0,
        "total withdrawals": item?.total_withdrawals?.aggregate?.sum?.amount || 0,
        "total invest2insure payments":
          item?.total_invest2insure_payments?.aggregate?.sum?.amount || 0,
        "total invest2insure payments balance":
          item?.total_invest2insure_payments_balance?.aggregate?.sum
            ?.premium_balance || 0,
        "driver payments schedules aggregate":
          item?.driver_payments_schedules_aggregate?.aggregate?.sum?.arrears ||
          0,
      }))
      // Flatten nested objects recursively
 
      // Extract table headers from the first item in paginatedData
      const firstItem = change[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = change?.map((item:any) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })  
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = "driver_report.csv"
      document.body.appendChild(a)
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      return
    }

    const change = data?.map((item: any) => ({
      "driver code": item?.driver_code,
      "full name": item?.full_name,
      address: item?.address,
      "phone number 1": item?.phone_number_1,
      email: item?.email,
      "id card type": item?.id_card_type,
      "id number": item?.id_number,
      network: item?.momo_wallet_details?.network,
      number: item?.momo_wallet_details?.number,
      "bank name": item?.bank_details?.bank_name,
      "account number": item?.bank_details?.account_number,
      "created at": moment(item?.created_at).format("LL"),
      "company staff name": item?.company_staff
        ? item.company_staff?.name
        : `${item?.sub_agent?.first_name} ${item?.sub_agent?.last_name}`,

      "total collections": item?.total_collections?.aggregate?.sum?.amount || 0,
      "total withdrawals": item?.total_withdrawals?.aggregate?.sum?.amount || 0,
      "total invest2insure payments":
        item?.total_invest2insure_payments?.aggregate?.sum?.amount || 0,
      "total invest2insure payments balance":
        item?.total_invest2insure_payments_balance?.aggregate?.sum
          ?.premium_balance || 0,
      "driver payments schedules aggregate":
        item?.driver_payments_schedules_aggregate?.aggregate?.sum?.arrears || 0,
    }))
    // Flatten nested objects recursively

    // Extract table headers from the first item in paginatedData
    const firstItem = change[0]
    const originalHeaders = Object.keys(firstItem!)
    const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
    // Transform data to match headers (Simplified)
    const transformedData = change?.map((item:any) => {
      const transformedItem: Record<string, string> = {};
      originalHeaders.forEach((originalKey, idx) => {
        const upperKey = upperHeaders[idx];
        transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
      });
      return transformedItem;
    });
    // Convert data to CSV format
    const csvData = Papa.unparse({
      fields: upperHeaders,
      data: transformedData!,
    })  

    // Create a Blob and download link
    const blob = new Blob([csvData], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    // Create a download link
    const a = document.createElement("a")
    a.href = url
    a.download = "driver_report.csv"
    document.body.appendChild(a)
    // Trigger a click on the link to start the download
    a.click()
    // Cleanup
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser?.colors])

  const reset =() =>{
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
  }

  return (
    <>
      <CustomHeader title="Reports" />

      <CustomModal
        title="Beneficiaries"
        open={open}
        onClose={() => setModalOpen(false)}
        size={"xl"}
        showClose={true}
        className={
          selectedRow?.driver_beneficiaries?.length! > 5
            ? "h-full overflow-scroll"
            : ""
        }
        children={
          <>
            {selectedRow?.driver_beneficiaries?.length! > 0 ? (
              <CardBody className="overflow-x-scroll px-0">
                <table className="w-full min-w-max table-auto text-left">
                  <HeaderRenderer
                    tableHead={[
                      "first name",
                      "surname",
                      "relationship",
                      "share percentage",
                    ]}
                  />
                  <tbody>
                    {selectedRow?.driver_beneficiaries?.map(
                      (item, index: number) => {
                        const isLast = index === paginatedData?.length - 1
                        const classes = isLast
                          ? "px-2 py-3 text-center"
                          : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                        return (
                          <tr
                            key={index}
                            className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                          >
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal text-xs capitalize"
                              >
                                {item?.first_name}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-bold text-xs capitalize"
                              >
                                {item?.surname}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal text-xs capitalize"
                              >
                                {item?.relationship}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal text-xs capitalize"
                              >
                                {item?.share_percentage}%
                              </Typography>
                            </td>
                          </tr>
                        )
                      }
                    )}
                  </tbody>
                </table>
              </CardBody>
            ) : (
              <>
                <div className=" flex items-center justify-center">
                  <Typography color="black" variant="h6">
                    No driver beneficiaries found
                  </Typography>
                </div>
              </>
            )}
          </>
        }
      />

      <div className="bg-black pt-5 rounded-t-2xl">
        <Typography
          variant="h6"
          style={{
            color:
              colors?.length! > 1
                ? `${colors![0]?.toLowerCase()}`
                : `${DEFAULTPRIMARYCOLOR}`,
          }}
          className="px-4 pb-4  font-bold leading-none opacity-70"
        >
          Reports <span className=" text-white">{totalPageSize}</span>
        </Typography>
      </div>
      <div className="mt-0 bg-white p-3 rounded-b-lg">
        <CardHeader floated={false} shadow={false} className="rounded-none">
          <div className="w-full  flex flex-col gap-y-6 mb-4">
            <div className="flex shrink-0 flex-col justify-end gap-2 sm:flex-row">
              <Tooltip content="Export as CSV">
                <Button
                  onClick={handleDownload}
                  variant="filled"
                  className="capitalize text-sm font-normal flex flex-wrap gap-2"
                  size="sm"
                >
                  <FiDownloadCloud size={20} />
                  <span>Download csv</span>
                </Button>
              </Tooltip>
            </div>

            <div className=" flex gap-x-4 items-center flex-col 2xl:flex-row gap-y-3 mb-5">
              <div className="w-full flex flex-row gap-x-2">
                <Input
                  crossOrigin="anonymous"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value)
                    if (e.target.value === "") {
                      setSearchText("")
                    }
                  }}
                  label="Search"
                  icon={<BiSearch className="h-5 w-5" />}
                />
                <Tooltip content="Search">
                  <Button
                    onClick={handleSearch}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap gap-2"
                    size="sm"
                  >
                    <span>Search</span>
                  </Button>
                </Tooltip>
              </div>

              <div className="flex flex-col xl:flex-row gap-3 justify-between mb-0">
                <div className="flex items-center space-x-2">
                  <label className="font-semibold text-gray-700">From</label>
                  <Input
                    type="datetime-local"
                    value={tempStartDate} // Remove 'Z' for input value
                    onChange={handleTempStartDateChange}
                    size="md"
                    className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div className="flex items-center space-x-2">
                  <label className="font-semibold text-gray-700">To</label>
                  <Input
                    type="datetime-local"
                    value={tempEndDate} // Remove 'Z' for input value
                    onChange={handleTempEndDateChange}
                    size="md"
                    className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div className="flex shrink-0 flex-col gap-4 justify-end sm:flex-row">
                  <Tooltip content="Apply Date filters">
                  <Button
                    onClick={handleDateChange}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap align-middle"
                    size="sm"
                  >
                    <span>Filter</span> 
                  </Button>
                  </Tooltip>                      
                <Tooltip content="Clear All Date filters">
                  <Button
                    onClick={reset}
                    variant="filled"
                    className="capitalize bg-red-400 text-sm font-normal flex flex-wrap"
                    size="sm"
                  >
                    <span>Clear</span>
                  </Button>
                </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-x-scroll px-0 sticky overflow-y-auto py-0">
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              <table className="w-full min-w-max table-auto text-left">
                <HeaderRenderer tableHead={Table_Headers} />
                <tbody>
                  {paginatedData?.map((item, index: number) => {
                    const isLast = index === paginatedData?.length - 1
                    const classes = isLast
                      ? "px-2 py-3 text-center"
                      : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <tr
                        key={index}
                        onClick={() => {
                          setSelectedRow(item)
                          setModalOpen(true)
                        }}
                        className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                      >
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.driver_code}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.full_name}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.address}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.phone_number_1}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs "
                          >
                            {item?.email}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.id_card_type}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.id_number}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Network:{" "}
                              <span className="font-normal">
                                {item?.momo_wallet_details?.network}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Number:{" "}
                              <span className="font-normal">
                                {item?.momo_wallet_details?.number}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        {/* <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize"
                      >
                        {item?.bank_details?.bank_name}
                      </Typography>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize"
                      >
                        {item?.bank_details?.account_number}
                      </Typography>
                    </td> */}
                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Bank name:{" "}
                              <span className="font-normal">
                                {item?.bank_details?.bank_name}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              account number:{" "}
                              <span className="font-normal">
                                {item?.bank_details?.account_number}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.created_at).format("LL")}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Full name:{" "}
                              <span className="font-normal">
                                {item?.company_staff
                                  ? `${item?.company_staff?.name}`
                                  : `${item?.sub_agent?.first_name} ${item?.sub_agent?.last_name}`}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Phone number:{" "}
                              <span className="font-normal">
                                {item?.company_staff
                                  ? item?.company_staff?.phone_number_one
                                  : item?.sub_agent?.phone_number}
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              User type:{" "}
                              <span className="font-normal">
                                {item?.company_staff
                                  ? "Company Staff"
                                  : "Sub Agent"}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS{" "}
                            {(
                              item?.total_collections.aggregate?.sum?.amount ??
                              0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS{" "}
                            {(
                              item?.total_withdrawals.aggregate?.sum?.amount ??
                              0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS{" "}
                            {(
                              item?.total_invest2insure_payments.aggregate?.sum
                                ?.amount ?? 0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS{" "}
                            {(
                              item?.total_invest2insure_payments_balance
                                ?.aggregate?.sum?.premium_balance ?? 0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS{" "}
                            {(item?.balance ?? 0).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS{" "}
                            {(
                              item?.driver_payments_schedules_aggregate
                                ?.aggregate?.sum?.arrears ?? 0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Tooltip content="Edit Admin">
                            <Button
                              color="green"
                              size="sm"
                              className="text-xs font-normal capitalize"
                              onClick={() => {
                                setSelectedRow(item)
                                setModalOpen(true)
                              }}
                              variant="filled"
                            >
                              View Beneficiaries
                            </Button>
                          </Tooltip>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
          {(loading || isFilterLoading) && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {(paginatedData?.length === 0 ||
            data?.length === 0) && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="black" variant="h6">
                No data found
              </Typography>
            </div>
          )}
        </CardBody>
      </div>

      {
        // <GeneralPagination
        // totalItems={
        //   searchText || startDate || endDate
        //     ? lengthOfItems
        //     : totalPageSize!
        // }
        //   itemsPerPage={pageSize}
        //   currentPage={activePage}
        //   onPageChange={handlePageChange}
        // />

        <PerPageAndPagination
        customColor="white"
          total={
            (searchText || startDate || endDate
              ? lengthOfItems
              : totalPageSize!) ?? 0
          }
          currentPage={activePage}
          setCurrentPage={setActivePage}
          perPage={pageSize}
          setPerPage={setPageSize}
        />
      }


    </>
  )
}

const HeaderRenderer = ({ tableHead }: { tableHead: string[] }) => (
  <thead className="bg-white sticky z-50 top-0">
    <tr>
      {tableHead.map((head) => (
        <th
          key={head}
          className="capitalize text-center border-y border-blue-gray-100 bg-blue-gray-50/50 p-4"
        >
          <Typography
            variant="small"
            color="blue-gray"
            className="font-bold leading-none opacity-70"
          >
            {head}
          </Typography>
        </th>
      ))}
    </tr>
  </thead>
)

export default Invest2InsureReport
